import HtmlBuilder from '@/class/HtmlBuilder';
import SelectField from '@/fields/SelectField';
import NumberField from '@/fields/NumberField';
import { ALERT_MSG, CalcFormSelectOptions, densityFieldOptions } from '@shared/data';
import { getLengthByFlange, isPryamik, isPryamikspn } from '@/includes/utils';
import SearchField from '@/fields/SearchField';
import NumblectField from '@/fields/NumblectField';
export var ErrorsLevel;
(function (ErrorsLevel) {
    ErrorsLevel[ErrorsLevel["ALERT"] = 0] = "ALERT";
    ErrorsLevel[ErrorsLevel["ERROR"] = 1] = "ERROR";
    ErrorsLevel[ErrorsLevel["WARN"] = 2] = "WARN";
    ErrorsLevel[ErrorsLevel["NONE"] = 3] = "NONE";
})(ErrorsLevel || (ErrorsLevel = {}));
const DuctErrors = [
    'Данные [m, s, e] не определены!',
    'Не хватает данных в elements[s][e]',
    `Не удалось найти поле 'thickness' в store[airDuct]`,
    'Не хватает данных в materialCost[m][thickness]',
    'Не хватает данных в flangeCost[m][fv]',
    `Не удалось забрать поле 'Шина' или 'Уголок' из flangeCost[m][fv]`,
    `Не удалось забрать поле 'прямик' или 'фасонка' из away`,
    `Не удалось забрать значение 'LParameter' по индексу - `,
];
class SchemeElements {
    constructor(fields) {
        this.rows = [];
        this._fields = fields;
        this._inputs = [];
        this._byNames = [];
    }
    each(cb) {
        this._byNames.forEach(cb);
    }
    update(scheme) {
        this._inputs.splice(0);
        this._byNames.splice(0);
        const rowElList = [];
        for (let row of scheme) {
            const rowEl = HtmlBuilder.createRow();
            for (let item of row) {
                const elem = this.createField(item);
                if (elem === null)
                    continue;
                rowEl.append(elem.block);
                const { name, type } = item;
                const byName = { name, type, elem };
                this._inputs.push(elem);
                this._byNames.push(byName);
            }
            rowElList.push(rowEl);
        }
        this.rows = rowElList;
    }
    createField(scheme) {
        var _a, _b, _c, _d, _e;
        const { label, name, type } = scheme;
        const search = ['p', 'ral', 'floor'];
        if (Object.keys(CalcFormSelectOptions).includes(type)) {
            const options = CalcFormSelectOptions === null || CalcFormSelectOptions === void 0 ? void 0 : CalcFormSelectOptions[type];
            const getCompleteAttrs = (options) => ({
                suggestions: options,
                qtyDisplayHints: 12,
                isAdaptiveField: true,
                minFieldWidth: '69px',
                hintsLimit: -1,
                showHintsAfterSelect: false,
                selectFirstOnBlur: true,
                isSortHints: true,
                inputFieldProps: { placeholder: '---' },
                isSimpleSearch: false,
                isWithMatchMark: true,
            });
            return search.includes(type)
                ? new SearchField(label, getCompleteAttrs(options))
                : new SelectField(label, options);
        }
        const getNumberAttrs = (name) => {
            var _a;
            const fields = [
                { name: 'count', attrs: () => ({ val: '1' }) },
                {
                    name: 'L',
                    attrs: () => {
                        var _a;
                        const el = this._fields.element.value;
                        if (isPryamik(el))
                            return { val: '1250' };
                        else if (isPryamikspn(el))
                            return { val: '3000' };
                        else if (el.includes('Переход П'))
                            return { val: '300', min: 300 };
                        else if (['Заглушка', 'Заглушка с сеткой'].includes(el))
                            return {
                                val: getLengthByFlange(((_a = CalcFormSelectOptions.roof) === null || _a === void 0 ? void 0 : _a[0]) || ''),
                            };
                        else
                            return { val: '' };
                    },
                },
            ];
            return ((_a = fields.find(it => it.name === name)) === null || _a === void 0 ? void 0 : _a.attrs()) || { val: '' };
        };
        switch (type) {
            case 'number': {
                const { val, min } = getNumberAttrs(name);
                return new NumberField(label, val, min);
            }
            case 'numblect': {
                const options = (((_a = scheme === null || scheme === void 0 ? void 0 : scheme.params) === null || _a === void 0 ? void 0 : _a.options) || []).map(it => String(it));
                const { val, min } = getNumberAttrs(name);
                const value = String(((_b = scheme === null || scheme === void 0 ? void 0 : scheme.params) === null || _b === void 0 ? void 0 : _b.value) || val);
                return new NumblectField(label, options, value, min);
            }
            case 'thickness': {
                const m = this._fields.material.value;
                const s = this._fields.section.value;
                const e = this._fields.element.value;
                const values = (_e = (_d = (_c = window.calcZV_ductsAdditionals) === null || _c === void 0 ? void 0 : _c[m]) === null || _d === void 0 ? void 0 : _d[s]) === null || _e === void 0 ? void 0 : _e[e];
                const options = Object.keys(values || {});
                const elem = new SelectField(label, options);
                if (e === 'фланец')
                    elem.block.style.display = 'none';
                return elem;
            }
            case 'plotnost': {
                return new SelectField(label, densityFieldOptions.map((it) => {
                    return Object.assign(Object.assign({}, it), { label: it.text.trim() || it.value });
                }));
            }
            default:
                return null;
        }
    }
    getValues(paramNames) {
        return paramNames.map(it => this.getValue(it));
    }
    getByNamesItem(paramName) {
        return this._byNames.find(it => it.name === paramName);
    }
    getByNamesItems(paramNames) {
        return paramNames.reduce((acc, it) => {
            acc[it] = this.getByNamesItem(it);
            return acc;
        }, {});
    }
    getFormFields(paramNames) {
        return paramNames.reduce((acc, it) => {
            var _a;
            acc[it] = (_a = this.getByNamesItem(it)) === null || _a === void 0 ? void 0 : _a.elem;
            return acc;
        }, {});
    }
    errorReport(level, msg) {
        switch (level) {
            case ErrorsLevel.ALERT:
                alert(msg);
                break;
            case ErrorsLevel.ERROR:
                console.error(msg);
                break;
            case ErrorsLevel.WARN:
                console.warn(msg);
                break;
        }
    }
    getValue(paramName, errorLevel = ErrorsLevel.ALERT) {
        const paramInfo = this.getByNamesItem(paramName);
        if (paramInfo === undefined) {
            const msg = `В форме отсутствует поле ${paramName}`;
            this.errorReport(errorLevel, msg);
            throw new Error('Отсутствует какие то данные в _byNames');
        }
        const { elem, type } = paramInfo;
        return (type === 'angle' ? +elem.value : elem.value);
    }
    getSafeValue(paramName, def = null, errorLevel = ErrorsLevel.WARN) {
        try {
            return this.getValue(paramName, errorLevel);
        }
        catch (e) {
            return def;
        }
    }
    getFieldsDescription() {
        const res = [];
        for (const el of this._inputs) {
            if (this._findParamName(el) === 'count')
                continue;
            res.push(this._getFieldDescription(el));
        }
        return res;
    }
    nice() {
        for (const inp of this._inputs) {
            if ('nice' in inp)
                inp.nice();
        }
    }
    remove() {
        for (const inp of this._inputs)
            if ('nice' in inp)
                inp.remove();
        for (let el of this.rows)
            el.remove();
    }
    calculateFlangesCost(flangesLengths) {
        var _a, _b;
        const prms = ['Чёрная сталь', 'Оцинкованная сталь'];
        let resultPrice = 0;
        let totalTireLength = 0;
        let totalAngleCount = 0;
        let tire2Len = 0;
        let tire3Len = 0;
        let angle2Count = 0;
        let angle3Count = 0;
        for (let i = 0; i < flangesLengths.length; i++) {
            const fn = `flange${i + 1}`;
            const fv = this.getValue(fn);
            if (fv === '---')
                continue;
            let m = this._fields.material.value;
            if (m === prms[0])
                m = prms[1];
            const flangePriceInfo = (_b = (_a = window === null || window === void 0 ? void 0 : window.calcZV_flangeCost) === null || _a === void 0 ? void 0 : _a[m]) === null || _b === void 0 ? void 0 : _b[fv];
            const meterTirePrice = flangePriceInfo === null || flangePriceInfo === void 0 ? void 0 : flangePriceInfo['Шина'];
            const anglePrice = flangePriceInfo === null || flangePriceInfo === void 0 ? void 0 : flangePriceInfo['Уголок'];
            if ([meterTirePrice, anglePrice].includes(undefined)) {
                console.error(DuctErrors[5]);
                throw new Error(ALERT_MSG.ERROR);
            }
            const flangeSize = flangesLengths[i];
            const [A, B] = flangeSize;
            const tireLength = (2 * (A + B)) / 1000;
            totalTireLength += tireLength;
            const tirePrice = tireLength * meterTirePrice;
            const anglesPrice = 4 * anglePrice;
            totalAngleCount += 4;
            resultPrice += tirePrice + anglesPrice;
            if (fv === 'Шина 20') {
                tire2Len += tireLength;
                angle2Count += 4;
            }
            else if (fv === 'Шина 30') {
                tire3Len += tireLength;
                angle3Count += 4;
            }
        }
        return {
            price: resultPrice,
            tireLength: totalTireLength,
            angleCount: totalAngleCount,
            tire2Len: tire2Len,
            tire3Len: tire3Len,
            angle2Count: angle2Count,
            angle3Count: angle3Count,
        };
    }
    _findParamName(el) {
        var _a;
        return ((_a = this._byNames.find(it => it.elem === el)) === null || _a === void 0 ? void 0 : _a.name) || null;
    }
    _getFieldDescription(field) {
        return `${field.label}=${field.value}`;
    }
}
export default SchemeElements;
